var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app drive-app"},[_c('Navigation',{ref:"nav",attrs:{"slideout":_vm.slideout}}),_c('div',{ref:"content",staticClass:"content",class:{fullscreen: _vm.fullscreen}},[_c('Flash',{attrs:{"success":_vm.currentSuccess,"error":_vm.currentError}}),_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }